var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16,
    stroke: "black",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.808 9.808C21.35 9.808 23.443 11.418 23.443 14.247C23.443 16.087 22.661 17.122 21.005 18.456C19.855 19.399 19.418 19.951 19.28 21.17H15.922C15.968 19.307 16.428 18.479 17.417 17.421C18.659 16.11 19.119 15.397 19.119 14.592C19.119 13.442 18.613 12.844 17.509 12.844C16.497 12.844 15.899 13.557 15.83 15.098H11.69C11.782 11.786 14.105 9.808 17.808 9.808ZM17.647 22.205C18.866 22.205 19.717 23.056 19.717 24.275C19.717 25.494 18.866 26.322 17.647 26.322C16.428 26.322 15.577 25.494 15.577 24.275C15.577 23.056 16.428 22.205 17.647 22.205Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteMark);
export default __webpack_public_path__ + "static/media/noteMark.0512c3ea2f310bfc8df88afb1ba69c16.svg";
export { ForwardRef as ReactComponent };